import React, { useContext, useState } from "react";
import CreditSection from "./Credit/CreditSection";
import AiSection from "./AI/AiSection";
import AgSection from "./Asset Gateway/AgSection";
import { sideBarContext } from "../../App";

function Dashboard() {
  const [current, setCurrent] = useState("credit");
  const { expanded } = useContext(sideBarContext);

  const dashboardToggle = [
    {
      name: "Credit",
      value: "credit",
    },
    {
      name: "Artificial Intelligence",
      value: "ai",
    },
    {
      name: "Asset Gateway",
      value: "ag",
    },
  ];
  return (
    <div
      className={` ${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh]`}
    >
      <div className="mx-[20px] mt-4  border-b-[3px] border-[#92e86c] rounded-t-lg  bg-white my-2">
        {dashboardToggle.map((item) => (
          <button
            className={`py-3 ${
              item.value === "ai" ? "px-12" : "px-12"
            } rounded-t-lg ${
              current === item.value ? "bg-[#92e86c] font-semibold" : ""
            }`}
            onClick={() => setCurrent(item.value)}
          >
            {item.name}
          </button>
        ))}
        {/* <button
          className={` py-3 px-12  rounded-t-lg ${
            current === "credit" ? "bg-[#92e86c] font-semibold" : ""
          }`}
          onClick={() => setCurrent("credit")}
        >
          Credit
        </button>{" "}
        <button
          className={`py-3 px-6 rounded-t-lg ${
            current === "ai" ? "bg-[#92e86c] font-semibold" : ""
          }`}
          onClick={() => setCurrent("ai")}
        >
          Artificial Intelligence
        </button> */}
      </div>

      {/* <div className="flex flex-col bg-[#F4F7FF] py-2 space-y-5 px-[20px] ">
        <UserBox users={users} isLoading={isLoading} />
        {userType !== "distributors" && pledgedAvailable && (
          <TopPledgedMutualFund checkPledged={checkPledged} />
        )}
        <DisbursementPledgedGraph />
        
        <CurrentOutstanding />
      </div> */}
      {current === "credit" && <CreditSection />}
      {current === "ai" && <AiSection />}
      {current === "ag" && <AgSection />}
    </div>
  );
}

export default Dashboard;
